import { combineReducers } from 'redux';
import quote from './quote';
import auth from './auth';
import ui from './ui';
import { connectRouter } from 'connected-react-router';

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    quote,
    auth,
    ui
});
